export default {
  'Resolution': 'रिज़ॉल्यूशन',
  'Frame rate': 'फ्रेम रेट',
  'The higher the frame rate, the smoother the animation': 'फ्रेम रेट जितना ज़्यादा होगा, एनीमेशन उतना ही सुचारु होगा।',
}